import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, testid }) => (
  <Reveal>
    <p className="font-mono text-[11px] tracking-[0.35em] text-amber uppercase">{eyebrow}</p>
    <h2
      data-testid={testid}
      className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-wide text-ivory mt-4 leading-tight"
    >
      {title}
    </h2>
  </Reveal>
);
